import { useDispatch, useSelector } from "react-redux";
import { downloadAnnualSecurityExcel } from "../thunks/downloadReportExcel";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useAnnualSecurityExcelDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.securityCommission.annualSecurity.downloadReportFetchState);
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadAnnualSecurityExcel()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
